import PropTypes from 'prop-types';
import { linkPropertiesShape, linkType } from './link';

// eslint-disable-next-line import/prefer-default-export
export const menuType = PropTypes.shape({
  ...linkPropertiesShape,
  submenu: PropTypes.arrayOf(linkType).isRequired,
});
